import { Injectable } from '@angular/core';
import { item } from '@scaffold/editor/items';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
/**Service for moving item in the Scaffold editor*/
export class MoveItemService {
  public selectedItem: item;
  itemPosition: Position;
  copyModifier = false;
  private _selectionChange: Subject<any> = new Subject();
  /**
   * Set the select scaffold component to be moved
   * @param toSelect Item to be selected
   */
  setSelection(toSelect: item): void {
    this.selectedItem = toSelect;
    this._selectionChange.next(toSelect);
  }
  /**Set the selected scaffold component being moved */
  getSelection(): item {
    return this.selectedItem;
  }
  /**Observavle for watching a scaffold component selection change*/
  moveSelection(): Observable<any> {
    return this._selectionChange.asObservable();
  }
  /**
   * Set the position of the selected scaffold component
   * @param ind New position
   * @param arr Target array
   */
  setPosition(ind: number, arr: any[]): void {
    if (ind != null && arr != null) {
      this.itemPosition = { ind: ind, arr: arr };
    } else {
      this.itemPosition = null;
    }
  }
  /**Get the postiotion of the currently selected scaffold component */
  getPosition(): any {
    return this.itemPosition;
  }
}

export class Position {
  ind: number;
  arr: any[];
}
